import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import { documentsService } from "services";
import { preAppActions, uiActions } from "store";

type UseSubmitPreApplicationMutationProps = {
	token: string;
	nextStep: Function;
	applicationId: number | string;
};

const useSubmitApplicationMutation = ({
	nextStep,
	token,
	applicationId,
}: UseSubmitPreApplicationMutationProps) => {
	const dispatch = useDispatch();
	function multiAction(actions) {
		actions?.map(a => dispatch(a));
	}

	return useMutation(() => documentsService.submitPreApplication(token, applicationId), {
		onMutate() {
			dispatch(uiActions.showSpinnerOverlay());
		},
		onSuccess() {
			nextStep();

			multiAction([
				uiActions.showSuccessNotification({
					title: "Pre Application sent successfully",
				}),
				preAppActions.resetApplicationState(),
				uiActions.showModal("SuccessModal"),
			]);
		},
		onError() {
			dispatch(
				uiActions.showErrorNotification({
					title: "Pre Application was not sent",
				}),
			);
		},
		onSettled() {
			dispatch(uiActions.hideSpinnerOverlay());
		},
	});
};

export default useSubmitApplicationMutation;
